module.exports = __webpack_public_path__ + "img/f9a6d214-1c38-47ab-a61c-c99a59438b12.fb6ae991.jpg";